<template>
  <section class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-body">
            <form-wizard
              title="Boleto Garantido Web"
              subtitle="Solicitação de Garantia"
              shape="tab"
              finish-button-text="Nova Garantia"
              color="#3c8dbc"
              ref="wizard"
            >
              <tab-content title="CONSULTA">
                <div class="row">
                  <div class="col-sm-6 col-sm-offset-3">
                    <div
                      :class="{'form-group': true, 'has-error':errors.has('consulta_cpf_cnpj') }"
                      style="text-align:center"
                    >
                      <label for="cpf" style="font-size: 20px;">Informe o CPF/CNPJ do cliente</label>
                      <input
                        v-mask="['###.###.###-##','##.###.###/####-##']"
                        class="form-control consulta-cpf"
                        name="consulta_cpf_cnpj"
                        type="text"
                        v-model="dados.cpf_cnpj"
                        v-validate="'required'"
                        ref="consulta_cpf_cnpj"
                      >
                      <span
                        v-show="errors.has('consulta_cpf_cnpj')"
                        class="help-block"
                      >É obrigatório informar um CPF/CNPJ para consulta</span>
                    </div>
                  </div>
                </div>
              </tab-content>

              <tab-content title="DADOS DO CLIENTE">
                <div class="row">
                  <div class="col-sm-3">
                    <div :class="{'form-group': true, 'has-error':errors.has('cpf_cnpj') }">
                      <label
                        for="cpf_cnpj"
                        style
                      >{{ this.dados.cpf_cnpj.length > 14 ? 'CNPJ':'CPF'}}</label>
                      <input
                        v-mask="['###.###.###-##','##.###.###/####-##']"
                        class="form-control"
                        name="cpf_cnpj"
                        type="text"
                        v-model="dados.cpf_cnpj"
                        :disabled="true"
                      >
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div :class="{'form-group': true, 'has-error':errors.has('nome_razao') }">
                      <label
                        for="nome_razao"
                      >{{ this.dados.cpf_cnpj.length > 14 ? 'Razão Social':'Nome Completo'}}</label>
                      <input
                        class="form-control"
                        name="nome_razao"
                        type="text"
                        v-model="dados.nome_razao"
                        v-validate="'required'"
                        ref="nome_razao"
                      >
                      <span v-show="errors.has('nome_razao')" class="help-block">Campo obrigatório</span>
                    </div>
                  </div>
                  <div class="col-sm-3">

                    <div :class="{'form-group': true, 'has-error':errors.has('data_nascimento') }">
                      <label for="data_nascimento">Dt. Nascimento</label>
                      <input
                        class="form-control"
                        name="data_nascimento"
                        type="date"
                        v-model="dados.data_nascimento"
                        v-validate="'required'"
                      >
                      <span
                        v-show="errors.has('data_nascimento')"
                        class="help-block"
                      >Campo obrigatório</span>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-2">
                    <div :class="{'form-group': true, 'has-error':errors.has('cep') }">
                      <label for="cep">CEP</label>
                      <input
                        class="form-control"
                        name="cep"
                        type="text"
                        v-model="dados.cep"
                        v-validate="'required'"
                        v-mask="'#####-###'"
                        ref="cep"
                        @blur="getEndereco()"
                      >
                      <span v-show="errors.has('cep')" class="help-block">Campo obrigatório</span>
                    </div>
                  </div>

                  <div class="col-sm-5">
                    <div :class="{'form-group': true, 'has-error':errors.has('endereco') }">
                      <label for="endereco">Endereço</label>
                      <input
                        class="form-control"
                        name="endereco"
                        type="text"
                        v-model="dados.endereco"
                        v-validate="'required'"
                      >
                      <span v-show="errors.has('endereco')" class="help-block">Campo obrigatório</span>
                    </div>
                  </div>

                  <div class="col-sm-2">
                    <div :class="{'form-group': true, 'has-error':errors.has('numero') }">
                      <label for="numero">Número</label>
                      <input
                        class="form-control"
                        name="numero"
                        type="text"
                        v-model="dados.numero"
                        v-validate="'required'"
                        ref="numero_endereco"
                      >
                      <span v-show="errors.has('numero')" class="help-block">Campo obrigatório</span>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div :class="{'form-group': true, 'has-error':errors.has('complemento') }">
                      <label for="complemento">Complemento</label>
                      <input
                        class="form-control"
                        name="complemento"
                        type="text"
                        v-model="dados.complemento"
                      >
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-5">
                    <div :class="{'form-group': true, 'has-error':errors.has('bairro') }">
                      <label for="bairro">Bairro</label>
                      <input
                        class="form-control"
                        name="bairro"
                        type="text"
                        v-model="dados.bairro"
                        v-validate="'required'"
                      >
                      <span v-show="errors.has('bairro')" class="help-block">Campo obrigatório</span>
                    </div>
                  </div>

                  <div class="col-sm-5">
                    <div :class="{'form-group': true, 'has-error':errors.has('cidade') }">
                      <label for="cidade">Cidade</label>
                      <input
                        class="form-control"
                        name="cidade"
                        type="text"
                        v-model="dados.cidade"
                        v-validate="'required'"
                        :disabled="true"
                      >
                      <span v-show="errors.has('cidade')" class="help-block">Cidade</span>
                    </div>
                  </div>

                  <div class="col-sm-2">
                    <div :class="{'form-group': true, 'has-error':errors.has('uf') }">
                      <label for="uf">Estado</label>
                      <input
                        class="form-control"
                        name="uf"
                        type="text"
                        v-model="dados.uf"
                        v-validate="'required'"
                        :disabled="true"
                      >
                      <span v-show="errors.has('uf')" class="help-block">Campo obrigatório</span>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div :class="{'form-group': true, 'has-error':errors.has('ref_comercial') }">
                      <label for="ref_comercial">Referência Comercial</label>
                      <input
                        class="form-control"
                        name="ref_comercial"
                        type="text"
                        v-model="dados.ref_comercial"
                      >
                    </div>
                  </div>

                  <div class="col-sm-3">
                    <div
                      :class="{'form-group': true, 'has-error':errors.has('tel_ref_comercial') }"
                    >
                      <label for="tel_ref_comercial">Telefone Ref. Comercial</label>
                      <input
                        class="form-control"
                        name="tel_ref_comercial"
                        type="text"
                        v-model="dados.tel_ref_comercial"
                        v-mask="['(##)####-####','(##)#####-####']"
                      >
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div :class="{'form-group': true, 'has-error':errors.has('ref_pessoal') }">
                      <label for="ref_pessoal">Referência Pessoal</label>
                      <input
                        class="form-control"
                        name="ref_pessoal"
                        type="text"
                        v-model="dados.ref_pessoal"
                        v-validate="'required'"
                      >
                      <span v-show="errors.has('ref_pessoal')" class="help-block">Campo obrigatório</span>
                    </div>
                  </div>

                  <div class="col-sm-3">
                    <div :class="{'form-group': true, 'has-error':errors.has('tel_ref_pessoal') }">
                      <label for="tel_ref_pessoal">Telefone Ref. Pessoal</label>
                      <input
                        class="form-control"
                        name="tel_ref_pessoal"
                        type="text"
                        v-model="dados.tel_ref_pessoal"
                        v-validate="'required'"
                        v-mask="['(##)####-####','(##)#####-####']"
                      >
                      <span
                        v-show="errors.has('tel_ref_pessoal')"
                        class="help-block"
                      >Campo obrigatório</span>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div :class="{'form-group': true, 'has-error':errors.has('ocupacao') }">
                      <label for="ocupacao">Ocupação</label>
                      <input
                        class="form-control"
                        name="ocupacao"
                        type="text"
                        v-model="dados.ocupacao"
                        v-validate="'required'"
                      >
                      <span v-show="errors.has('ocupacao')" class="help-block">Campo obrigatório</span>
                    </div>
                  </div>
                  <div class="col-sm-2">
                    <div :class="{'form-group': true, 'has-error':errors.has('renda') }">
                      <label for="renda">Renda</label>
                      <money name="renda" v-validate="'min_value: 300'" class="form-control" v-model="dados.renda" v-bind="money"></money>
                       <span v-show="errors.has('renda')" class="help-block">A renda informada não pode ser menor que R$ 300,00</span>
                    </div>
                  </div>

                  <div class="col-sm-3">
                    <div :class="{'form-group': true, 'has-error':errors.has('telefone1') }">
                      <label for="telefone1">Telefone 1</label>
                      <input
                        class="form-control"
                        name="telefone1"
                        type="text"
                        v-model="dados.telefone1"
                        v-validate="'required'"
                        v-mask="['(##)####-####','(##)#####-####']"
                      >
                      <span v-show="errors.has('telefone1')" class="help-block">Campo obrigatório</span>
                    </div>
                  </div>

                  <div class="col-sm-3">
                    <div :class="{'form-group': true, 'has-error':errors.has('telefone2') }">
                      <label for="telefone2">Telefone 2</label>
                      <input
                        class="form-control"
                        name="telefone2"
                        type="text"
                        v-model="dados.telefone2"
                        v-mask="['(##)####-####','(##)#####-####']"
                      >
                    </div>
                  </div>
                </div>
                <div class="row" v-if="this.dados.cpf_cnpj.length > 14">
                  <div class="col-sm-9">
                    <div :class="{'form-group': true, 'has-error':errors.has('socio_avalista') }">
                      <label for="socio_avalista">Sócio Avalista</label>
                      <input
                        class="form-control"
                        name="socio_avalista"
                        type="text"
                        v-model="dados.socio_avalista"
                        v-validate="'required'"
                      >
                      <span
                        v-show="errors.has('socio_avalista')"
                        class="help-block"
                      >Campo obrigatório</span>
                    </div>
                  </div>

                  <div class="col-sm-3">
                    <div :class="{'form-group': true, 'has-error':errors.has('cpf_avalista') }">
                      <label for="cpf_avalista">CPF Avalista</label>
                      <input
                        class="form-control"
                        name="cpf_avalista"
                        type="text"
                        v-model="dados.cpf_avalista"
                        v-validate="'required'"
                      >
                      <span v-show="errors.has('cpf_avalista')" class="help-block">Campo obrigatório</span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <label>Documentos</label>
                    <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"></vue-dropzone>
                  </div>
                </div>
              </tab-content>

              <tab-content title="DADOS DA SOLICITAÇÃO">
                <div class="row">
                  <div class="col-sm-4 col-sm-offset-4">
                    <div
                      :class="{'form-group': true, 'has-error':errors.has('qtd_titulos') }"
                      style="text-align:center"
                    >
                      <label for="valor" style="font-size: 20px;">Qtd. de Parcelas</label>
                      <select
                        class="form-control solicitacao-dados"
                        name="qtd_titulos"
                        v-model="dados.qtd_titulos"
                        ref="qtd_titulos"
                      >
                        <option value>--Selecione--</option>
                        <option v-for="(parcela, index) in parcelas" :key="index" :value="parcela">{{ parcela.toString().padStart(2, '0') }}</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-8 col-sm-offset-2" style="font-size: 15px;">
                    <table
                      aria-describedby="example1_info"
                      role="grid"
                      id="example1"
                      class="table table-bordered table-striped"
                    >
                      <thead>
                        <tr role="row">
                          <th style="width: 10%">Parcela</th>
                          <th style="width: 45%">Valor</th>
                          <th style="width: 45%">Vencimento</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="titulo in dados.titulos"
                          :key="titulo.parcela"
                          class="even"
                          role="row"
                        >
                          <td>{{ titulo.parcela }}ª</td>
                          <td>
                            <div class="form-group" style="text-align:center">
                              <money
                                class="form-control solicitacao-dados"
                                v-model="titulo.valor"
                                v-bind="money"
                              ></money>
                            </div>
                          </td>
                          <td>
                            <div class="form-group" style="text-align:center">
                              <input
                                v-model="titulo.vencimento"
                                class="form-control solicitacao-dados"
                                type="date"
                                @blur="titulo.parcela == 1?preencheOutrasParcelas():''"
                              >
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </tab-content>
              <tab-content title="RESULTADO">
                <div class="row">
                  <div
                    class="col-sm-12"
                    style="text-align:center"
                    v-if="responseConsulta.status == 900"
                  >
                    <h3>Que pena! Não conseguimos aprovar essa solicitação!</h3>
                    <p style="font-size:16px;">O cliente possui uma ou mais restrições comerciais.</p>
                    <div class="row" v-html="responseConsulta.consulta"></div>
                  </div>

                  <div
                    class="col-sm-12"
                    style="text-align:center"
                    v-if="responseConsulta.status == 200"
                  >
                    <h3>Dados da solicitação enviados para análise!</h3>
                    <p style="font-size:16px;">
                      Para efetivar a garantia, é necessário entrar em contato pelo
                      <a
                        href="http://chat.credipremium.com.br/chat"
                        target="_blank"
                      >
                        <strong style="font-size:18px;">CHAT</strong>
                      </a> e informar seu código de acesso.
                    </p>
                  </div>
                </div>
              </tab-content>

              <template slot="footer" slot-scope="props">
                <div class="wizard-footer-left">
                  <wizard-button
                    v-if="props.activeTabIndex > 0 && !props.isLastStep"
                    @click.native="props.prevTab()"
                    :style="props.fillButtonStyle"
                  >
                    <i class="fa fa-backward"></i> Anterior
                  </wizard-button>
                </div>
                <div class="wizard-footer-right">
                  <wizard-button
                    v-if="props.activeTabIndex == 0"
                    @click.native="consultaDocumento(props)"
                    class="wizard-footer-right"
                    :style="props.fillButtonStyle"
                  >
                    <i class="fa fa-forward"></i> Próximo
                  </wizard-button>
                  <wizard-button
                    v-if="props.activeTabIndex == 1"
                    @click.native="showDadosSolicitacao(props)"
                    class="wizard-footer-right"
                    :style="props.fillButtonStyle"
                  >
                    <i class="fa fa-forward"></i> Próximo
                  </wizard-button>

                  <wizard-button
                    v-if="props.activeTabIndex == 2"
                    @click.native="enviaDados(props)"
                    class="wizard-footer-right"
                    :style="props.fillButtonStyle"
                  >
                    <i class="fa fa-forward"></i> Enviar Dados
                  </wizard-button>

                  <wizard-button
                    v-if="props.isLastStep"
                    @click.native="getNovaGarantia()"
                    class="wizard-footer-right finish-button"
                    :style="props.fillButtonStyle"
                  >
                    <i class="fa fa-plus"></i> Nova Garantia
                  </wizard-button>
                </div>
              </template>
            </form-wizard>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from "axios"; // Cliente para requisição http
import { mask } from "vue-the-mask";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { Money } from "v-money";

export default {
  directives: { mask },
  data() {
    return {
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      },
      dropzoneOptions: {
        url: `${this.$store.state.serverURI}/api/pessoa/uploadDocumento`,
        method: "POST",
        maxFiles: 3,
        maxFilesize: 50,
        timeout: 99999999999999,
        autoQueue: true,
        parallelUploads: 2,
        paramName: "arquivo",
        dictDefaultMessage: "Arraste ou selecione seus arquivos...",
        dictResponseError: "Servidor não configurado!",
        acceptedFiles: '.jpeg, .jpg, .png',
        headers: this.$store.getters.getHeaderAuthFile,
        withCredentials: true,
        sending: (file, xhr, formData) => {
          formData.append('pessoa_id', this.responseConsulta.obj.pessoa_id);
        }
      },
      dados: {
        cpf_cnpj: "",
        nome_razao: "",
        data_nascimento: "",
        cep: "",
        endereco: "",
        numero: "",
        complemento: "",
        bairro: "",
        cidade: "",
        uf: "",
        ref_comercial: "",
        tel_ref_comercial: "",
        ref_pessoal: "",
        tel_ref_pessoal: "",
        ocupacao: "",
        renda: 0,
        telefone1: "",
        telefone2: "",
        qtd_titulos: null,
        titulos: []
      },
      responseConsulta: {
        status: null,
        obj: null,
        consulta: ""
      },
			parcelas: []
    };
  },
  mounted() {
		const maxParcelas = this.$store.state.user.empresa.qtd_max_parcelas
		const parcelas = []
		for (let i = 2; i<=maxParcelas; i++) {
			parcelas.push(i)
		}

		this.parcelas = parcelas
    this.$nextTick(() => {
      this.$refs.consulta_cpf_cnpj.focus();
    });
  },

  methods: {
    getNovaGarantia() {
      this.$router.go(0);
    },
    consultaDocumento(props) {
      /*
        this.$swal({
							title: "Importando, aguarde...",
							text: "Esta ação pode demorar um pouco.",
							imageUrl: "/static/img/Rolling-green.gif",
							showConfirmButton: false,
							allowOutsideClick: false
						});
      */
      if (this.dados.cpf_cnpj == "") {
        return false;
      }
      if (!this.validaCpfCnpj(this.dados.cpf_cnpj)) {
        this.$swal({
          type: "warning",
          title: "Informe um CPF/CNPJ válido!"
        }).then(() => {});
        return false;
      }
      let config = this.$store.getters.getHeaderAuth;
      config.params = {documento: this.dados.cpf_cnpj};
      axios
        .get(
          `${this.$store.state.serverURI}/api/garantia/consultaDocumento`,
          config
        )
        .then(response => {
          this.responseConsulta = response.data;
          if (response.data.status == 900) {
            this.$refs.wizard.changeTab(0, 3);
          } else {
            this.showFormDadosCliente(props);
          }
        })
        .catch(error => {
          console.log(error);
          this.$store.commit("throwException", error);
        });
    },
    showFormDadosCliente(props) {
      props.nextTab();
      this.getPessoaById();
    },
    preencheOutrasParcelas() {
      let valor = this.dados.titulos[0].valor;
      let vencimento = this.dados.titulos[0].vencimento;

      let ano = parseInt(vencimento.substr(0, 4));
      let mes = parseInt(vencimento.substr(5, 2));
      let dia = parseInt(vencimento.substr(8, 2));

      // console.log(String(mes).padStart(2, '0'));

      this.dados.titulos.map(titulo => {
        if (titulo.parcela != 1) {
          titulo.valor = valor;
          if (mes == 12) {
            mes = 0;
            ano = ano + 1;
          }
          titulo.vencimento =
            ano +
            "-" +
            String(mes + 1).padStart(2, "0") +
            "-" +
            String(dia).padStart(2, "0");
          mes++;
        }
      });
    },
    showDadosSolicitacao(props) {
      this.$validator.validate().then(valid => {
        console.log(valid);
        if (valid) {
          props.nextTab();
        }
        return false;
      });

      // this.$refs.wizard.changeTab(index, 2);
    },
    enviaDados(props) {
      this.dados.obj = this.responseConsulta.obj;
      axios
        .post(
          `${this.$store.state.serverURI}/api/garantia/solicitaGarantia`,
          this.dados,
          this.$store.getters.getHeader
        )
        .then(response => {
          if (response.data.status != 200) {
            this.$swal({
                type: "warning",
                title: response.data.title,
                text: response.data.msg
              }).then(() => {
               return false;
              });
          } else {
            props.nextTab();
          }
        })
        .catch(error => {
          this.$store.commit("TOGGLE_LOADING");
          console.log(error);
          this.response = "Ocorreu uma falha no envio das informações!";
        });
    },

    getPessoaById() {
      let config = this.$store.getters.getHeaderAuth;
      axios
        .get(
          `${this.$store.state.serverURI}/api/pessoa/getById/${
            this.responseConsulta.obj.pessoa_id
          }`,
          config
        )
        .then(response => {
          this.dados.cpf_cnpj = response.data.cpf_cnpj;
          this.dados.nome_razao = response.data.nome_razao;
          this.dados.data_nascimento = response.data.data_nascimento;
          this.dados.cep = response.data.cep;
          this.dados.endereco = response.data.endereco;
          this.dados.numero = response.data.numero;
          this.dados.complemento = response.data.complemento;
          this.dados.bairro = response.data.bairro;
          this.dados.cidade = response.data.cidade;
          this.dados.uf = response.data.uf;
          this.dados.ref_comercial = response.data.ref_comercial;
          this.dados.tel_ref_comercial = response.data.tel_ref_comercial;
          this.dados.ref_pessoal = response.data.ref_pessoal;
          this.dados.tel_ref_pessoal = response.data.tel_ref_pessoal;
          this.dados.ocupacao = response.data.ocupacao;
          if (response.data.renda == null) {
            this.dados.renda = 0;
          } else {
            this.dados.renda = response.data.renda;
          }
          this.dados.telefone1 = response.data.telefone1;
          this.dados.telefone2 = response.data.telefone2;

          this.$nextTick(() => {
            this.$refs.nome_razao.focus();
          });
        })
        .catch(error => {
          console.log(error);
          this.$store.commit("throwException", error);
        });
    },

    getEndereco() {
      if (this.dados.cep && this.dados.cep != "") {
        this.$store.commit("TOGGLE_LOADING");
        axios
          .get(`https://viacep.com.br/ws/${this.dados.cep}/json/`)
          .then(response => {
            console.log(response.data);
            if (response.data.erro) {
              this.$swal({
                type: "warning",
                title: "Digite um CEP válido!",
                text: ""
              }).then(() => {
                this.dados.cep = "";
                this.dados.endereco = "";
                this.dados.bairro = "";
                this.dados.cidade = "";
                this.dados.uf = "";
                this.$refs.cep.focus();
              });
              return false;
            }

            this.dados.endereco = response.data.logradouro;
            this.dados.bairro = response.data.bairro;
            this.dados.cidade = response.data.localidade;
            this.dados.uf = response.data.uf;
            this.$store.commit("TOGGLE_LOADING");

            this.$refs.numero_endereco.focus();
          })
          .catch(() => {
            this.$swal({
              type: "warning",
              title: "Não conseguimos buscar seu endereço!",
              text: "Por favor, digite um CEP válido!"
            });
          });
      }
    },
    validaCpfCnpj() {
      if (
        this.dados.cpf_cnpj == "16.205.932/0001-00" ||
        this.dados.cpf_cnpj == "16205932000100"
      ) {
        return false;
      }
      if (this.dados.cpf_cnpj.length == 14) {
        return this.validaCpf();
      } else if (this.dados.cpf_cnpj.length == 18) {
        return this.validaCnpj();
      }
      return false;
    },

    validaCpf() {
      var valor = this.dados.cpf_cnpj;
      valor = valor.toString();
      valor = valor.replace(/[^0-9]/g, "");
      var digitos = valor.substr(0, 9);
      var novoCpf = this.calcDigitosCpf(digitos);
      novoCpf = this.calcDigitosCpf(novoCpf, 11);
      if (novoCpf === valor) {
        return true;
      }
      return false;
    },
    validaCnpj() {
      var valor = this.dados.cpf_cnpj;
      valor = valor.toString();
      valor = valor.replace(/[^0-9]/g, "");
      var cnpjOriginal = valor;
      var primeirosNumerosCnpj = valor.substr(0, 12);
      var primeiroCalculo = this.calcDigitosCnpj(primeirosNumerosCnpj, 5);
      var segundoCalculo = this.calcDigitosCnpj(primeiroCalculo, 6);
      var cnpj = segundoCalculo;
      if (cnpj === cnpjOriginal) {
        return true;
      }
      return false;
    },

    calcDigitosCpf(digitos, posicoes) {
      if (posicoes != 11) {
        posicoes = 10;
      }
      var somaDigitos = 0;
      digitos = digitos.toString();

      for (var i = 0; i < digitos.length; i++) {
        somaDigitos = somaDigitos + digitos[i] * posicoes;
        posicoes--;
        if (posicoes < 2) {
          posicoes = 9;
        }
      }

      somaDigitos = somaDigitos % 11;
      if (somaDigitos < 2) {
        somaDigitos = 0;
      } else {
        somaDigitos = 11 - somaDigitos;
      }
      var cpf = digitos + somaDigitos;
      return cpf;
    },

    calcDigitosCnpj(digitos, posicoes) {
      if (posicoes != 5) {
        posicoes = 6;
      }
      var somaDigitos = 0;
      digitos = digitos.toString();

      for (var i = 0; i < digitos.length; i++) {
        somaDigitos = somaDigitos + digitos[i] * posicoes;
        posicoes--;
        if (posicoes < 2) {
          posicoes = 9;
        }
      }

      somaDigitos = somaDigitos % 11;
      if (somaDigitos < 2) {
        somaDigitos = 0;
      } else {
        somaDigitos = 11 - somaDigitos;
      }
      var cpf = digitos + somaDigitos;
      return cpf;
    }
  },
  watch: {
    "dados.qtd_titulos": function(val) {
      let titulos = [];
      for (let i = 0; i < val; i++) {
        let obj = {
          parcela: i + 1,
          valor: 0,
          vencimento: null
        };
        titulos.push(obj);
      }
      this.dados.titulos = titulos;
    }
  },

  components: {
    vueDropzone: vue2Dropzone,
    Money
  }
};
</script>

<style scoped>
.consulta-cpf {
  font-size: 40px;
  text-align: center;
  padding: 30px;
}

.solicitacao-dados {
  font-size: 20px;
  height: 40px;
  text-align: center;
  padding: 8px;
}
input {
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// nova.vue?1b2b8632